<template>
  <div class="row">
    <SwappingSquaresSpinner v-if="this.$store.getters.isLoading"
      :animation-duration="1000"
      :size="90"
      :color="this.$store.getters.config.palette.primary"
      style="margin: auto; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);"
    />
    <div class="flex xs12" v-if="!this.$store.getters.isLoading">
      <div class="row">
        <div :class="subscription.isFree ? 'flex xs12 md12 pricing-table' : 'flex xs12 sm12 md12 lg12 x12 pricing-table'" v-for="subscription in subscriptions" v-bind:key="subscription.subscriptionId">
          <!--          <va-card v-if="subscription.isFree" stripe="primary">-->
          <!--            <div class="row">-->
          <!--              <div class="flex xs12" style="text-align: center;">-->
          <!--                <h5>15 μέρες δωρεάν!</h5>-->
          <!--                <p>Η 15 μέρες περιλαμβάνουν 100 ψηφιακά εισιτήρια ώστε να έχετε όλοι την άνεση να δοκιμάσετε την πλατφόρμα μας.-->
          <!--                  Αφού λήξουν η 15 μέρες θα πρέπει να αγοράσετε κάποιο πακέτο επί πληρωμή για να ξεκλειδώσετε την πλατφόρμα μας για ένα έτος.</p>-->
          <!--                <va-button style="margin-top: 30px !important;" :disabled="isPaymentLoading"-->
          <!--                  @click="completeFreePayment()" class="my-0">Ενεργοποιήστε τώρα χωρίς κάρτα</va-button>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </va-card>-->
          <div v-if="subscription.name === 'Your Gateways'" class="va-card" style="padding-top: 20px;">
            <div class="va-card__body">
              <div>
                <div class="pricing-option">
                  <i class="material-icons">important_devices</i>
                  <h1>Enterprise Valet Experience</h1>
                  <hr/>
                  <p>Are you running an enterprise with high demand? Looking to save more by integrating your own SMS and payment provider? Our enterprise subscription is tailor-made for you.<br/> </p>
                  <!--                  <p v-html="subscription.description">{{subscription.description}}</p>-->
                  <hr/>
                  <div class="back">
                    <!--                      :disabled="$store.getters.localUserSubscription === null ? false : $store.getters.localUserSubscription.subscriptionId === subscription.subscriptionId"-->
                    <va-button
                      :disabled="$store.getters.localUserSubscription === null ? false : $store.getters.localUserSubscription.subscriptionId === subscription.subscriptionId"
                      @click="toPayment(subscription.subscriptionId)" class="my-0">{{ subscription.price === 0 ? 'Subscribe for free' : 'Subscribe now' }}</va-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex xs12 lg12" v-if="this.$store.getters.localUserSubscription !== null">
          <va-list fit class="mb-2">
            <va-list-label style="font-size: 18px; padding: 10px 27px;">
              {{ $t('subscriptions.subscriptionPacks') }}
            </va-list-label>

            <template v-for="(item) in this.subscriptionPacks">
              <va-item v-if="item.period !== -1" :key="item.subscriptionPackId" clickable>
                <va-item-section>
                  <va-item-label>
                    {{ item.name }}
                  </va-item-label>
                </va-item-section>
                <va-item-section>
                  <va-item-label>
                    {{ item.price }} {{getCurrencySign}}
                  </va-item-label>
                </va-item-section>
                <va-item-section>
                  <va-item-label>
                    {{ item.period }} / {{ item.period > 1 ? $t('subscriptions.months') : $t('subscriptions.month') }}
                  </va-item-label>
                </va-item-section>
                <va-item-section>
                  <va-item-label>
                    {{ item.amount }} / {{ $t('subscriptions.tickets') }}
                  </va-item-label>
                </va-item-section>
                <va-item-section>
                  <va-item-label>
                    {{ Math.round(item.price * item.amount) }} {{getCurrencySign}}
                  </va-item-label>
                </va-item-section>
                <va-item-section side>
                  <va-button flat small color="gray" @click="toSubscriptionPacks(item.subscriptionPackId)" icon-right="fa fa-credit-card"></va-button>
                </va-item-section>
              </va-item>
            </template>
          </va-list>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SwappingSquaresSpinner } from 'epic-spinners'
import errorHandlerMixin from '@/mixin/errorHandlerMixin'

export default {
  components: { SwappingSquaresSpinner },
  mixins: [errorHandlerMixin],
  name: 'Subscriptions',
  data () {
    return {
      subscriptions: [],
      existingDisable: false,
      isPaymentLoading: false,
      subscriptionPacks: [],
    }
  },
  methods: {
    toPayment (subscriptionId) {
      this.$router.push({
        name: 'payment',
        params: { subscriptionId: subscriptionId },
      })
    },
    toSubscriptionPacks (subscriptionPackId) {
      this.$router.push({
        name: 'payment-pack',
        params: { subscriptionPackId: subscriptionPackId },
      })
    },
    getPacksForSubscription () {
      if (this.$store.getters.localUserSubscription !== null) {
        const packs = this.subscriptions.filter((item) => {
          return item.subscriptionId === this.$store.getters.localUserSubscription.subscriptionId
        })
        this.subscriptionPacks = packs[0].subscriptionPacks
      }
      this.$store.commit('setLoading', false)
    },
    async completeFreePayment () {
      this.isPaymentLoading = true
      await this.$store.dispatch('makeFreePayment').then((resp) => this.$router.push({
        name: 'payment-completed',
        params: { paymentId: resp.data.message.paymentId },
      })).catch(error => {
        this.errorHandler(error.response)
        this.isPaymentLoading = false
      })
    },
    existingDisableSubscription () {
      if (this.$store.getters.localUserSubscription === null) {
        this.existingDisable = false
      } else if (this.$store.getters.localUserSubscription.subscriptionId === this.subscription.subscriptionId) {
        this.existingDisable = true
      }
    },
    async initSubscriptions () {
      this.subscriptions.splice(0, this.subscriptions.length, ...this.$store.getters.subscriptions)
    },
  },
  computed: {
    getCurrencySign () {
      return this.$store.getters.authenticationData.currency.currencySign
    },
  },
  mounted () {
    this.$store.commit('setLoading', true)
    this.$store.dispatch('getSubscriptions')
      .then(() => this.initSubscriptions()).then(() => this.getPacksForSubscription())
      .catch(error => {
        this.errorHandler(error.response)
        this.isPaymentLoading = false
      })
  },
}
</script>

<style type="scss" scoped>
  .pricing-table {
    text-align: center;
  }

  .pricing-option {
    background: white;
    text-align: center;
    transition: all 0.3s ease-in-out;

    :nth-child(even) {
      margin: 0 2%;
    }

    :hover {
      cursor: pointer;
      transform: scale(1.04);

      i,
      h1,
      span,
      b {
        color: #f85e6a;
      }

      .front {
        opacity: 0;
        visibility: hidden;
      }

      .back {
        opacity: 1 !important;
        visibility: visible !important;
        margin-top: 30px;
        text-align: center;

        a.button {
          transform: translateY(0) !important;
        }
      }
    }

    i {
      font-size: 3rem;
      color: #d8d8d8;
      transition: all 0.3s ease-in-out;
    }

    h1 {
      margin: 10px 0;
      color: #212121;
      transition: all 0.3s ease-in-out;
    }

    p {
      color: #999999;
      padding: 0 10px;
      line-height: 1.3;
    }
  }

  .pricing-option hr {
    border: none;
    border-bottom: 1px solid #f0f0f0;
  }

  .price {
    position: relative;

    .front {
      span.price {
        font-size: 2rem;
        text-transform: uppercase;
        margin-top: 20px;
        display: block;
        font-weight: 700;
        position: relative;

        b {
          font-size: 1rem;
          margin-left: 2px;
          font-weight: 600;
        }
      }
    }
  }

  .price .back {
    transition: all 0.3s ease-in-out;
    margin-top: 20px;

    a.button {
      background: #f85e6a;
      padding: 15px 20px;
      display: inline-block;
      text-decoration: none;
      color: white;
      position: absolute;
      font-size: 13px;
      top: -5px;
      left: 0;
      right: 0;
      width: 150px;
      margin: auto;
      text-transform: uppercase;
      transform: translateY(20px);
      transition: all 0.3s ease-in-out;

      :hover {
        background: darken(#f85e6a, 10%);
      }
    }
  }

  @media screen and (max-width: 600px) {
    .pricing-table {
      .pricing-option {
        padding: 5%;
        width: 90%;

        &:nth-child(even) {
          margin: 30px 0 !important;
        }
      }
    }
  }
</style>
